// extracted by mini-css-extract-plugin
export var smallSpinner = "_sm-0";